import React, { Fragment, useState, useEffect } from "react";
import { Input } from "@components";
import { getInstitutions } from "@api";

const InstitutionsSelect = ({ onSelect, showProviderError, type = "payments" }) => {

  const [institutions, setInstitutions] = useState(null);
  const [displayed, setDisplayed] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const popular = ["barclays-sandbox"]

  useEffect(() => {
    async function fetchData() {
      const institutionData = await getInstitutions(type);
      setInstitutions(institutionData);
      setDisplayed(institutionData); // make popular
    }

    if (!institutions) {
      fetchData();
    }
    else if (searchTerm) {
      setDisplayed(institutions.filter(x => x.name.toLowerCase().includes(searchTerm)).slice(0,8));
    }
    else {
      setDisplayed(institutions.filter(x => popular.includes(x.id)).slice(0, 8));
    }
  }, [searchTerm]);


  return (
    <>
      {showProviderError && <p className="text-danger rounded border border-danger p-2 fs-6">
        Unfortunately the bank selected was unable to process your payment at the moment. Please select a different bank to continue.
      </p>}
      <Input value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} placeholder="Search for your bank" />
      <div className="mt-6 py-6 border-t border-zinc-200 text-sm text-zinc-500">{searchTerm ? "Search results" : "Most popular banks"}</div>
      <div className="grid grid-cols-2 gap-2">
        {displayed
          ? displayed.map(x => <div key={x.id} role="button" onClick={() => onSelect(x)} className="border border-zinc-200 pl-3 py-4 pr-5 rounded-lg flex items-center gap-3 h-16 shadow-sm">
            <img className="size-8" src={x.iconUrl} alt={x.name} />
            <span className="text-sm">{x.name}</span>
          </div>)
          : Array.from({ length: 8 }).map((_, i) => <div key={i} className="border border-zinc-200 pl-3 py-4 pr-5 rounded-lg flex items-center gap-3 h-16 shadow-sm animate-pulse">
            <div className="size-8 rounded-full bg-zinc-200 shrink-0" />
            <div className="h-3 flex-1 max-w-24 rounded bg-zinc-200" />
          </div>)}
      </div>

    </>
  );
}

export default InstitutionsSelect;